import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import { Loader } from "../customComponents/components";

const RouteWrapper = ({ component: Component, layout: Layout, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => (
                <Layout {...props}>
                    <Suspense fallback={<Loader />}>
                        <Switch>{rest.routes}</Switch>
                    </Suspense>
                </Layout>
            )}
        />
    );
};

export default RouteWrapper;
